// @mui
import { List } from '@mui/material';
// locales
import { useLocales } from '../../../locales';
//
import { StyledSubheader } from './styles';
import NavList from './NavList';
import { NavListProps } from '../types';

// ----------------------------------------------------------------------

type Props = {
  group: {
    subheader: string;
    items: NavListProps[];
  };
};

export default function NavSection({ group }: Props) {
  const { translate } = useLocales();

  return (
    <List component="nav" disablePadding sx={{ px: 1 }}>
      {group.subheader && (
        <StyledSubheader disableSticky>{String(translate(group.subheader))}</StyledSubheader>
      )}
      <List sx={{ py: 0, mx: 1.5 }}>
        {group.items.map((list) => (
          <NavList key={list.title + list.path} data={list} depth={1} hasChild={!!list.children} />
        ))}
      </List>
    </List>
  );
}
